module.exports = __webpack_public_path__ + "img/hot_curator.1413bd54.jpg";